/**
 * Customized for:
 * - Add array parameter for productIsA
 */

import { ProductType } from '@/data/types/Product';

export const productIsA = (product: ProductType | undefined, type: string | string[]) => {
	if (Array.isArray(type)) {
		return type.some((t) => product?.type === t);
	}

	return product?.type === type;
};

export const isKitOrBundleType: Record<string, boolean> = {
	package: true,
	bundle: true,
};
